import React from "react";
import { periods, termTypes } from "_constants";
import cx from "classnames";
import PropTypes from "prop-types";

import TitledInputDropdown from "components/TitledInputDropdown";
import { Translate } from "utils";

import styles from "forms/forms.css";

const { t } = new Translate();

const PeriodField = ({
  field: { name, value = {} },
  isEdit,
  label,
  form: { errors, setFieldValue, submitCount },
  onEdit,
  isInline,
  isTerm,
}) => {
  const period = value.period || Object.keys(periods)[0];

  return (
    <div className={cx(styles.field, { [styles.inline]: isInline })}>
      <TitledInputDropdown
        dropdownValue={period}
        dropdownValues={isTerm ? termTypes : Object.keys(periods)}
        isEdit={isEdit}
        isRequired={errors[name] && !!submitCount}
        onEdit={onEdit}
        onInput={(v) => setFieldValue(name, { period, value: parseFloat(v) })}
        onSelect={(p) => setFieldValue(name, { ...value, period: p })}
        title={label}
        value={value.value}
        valueExtractor={(p) => t(`units.${p}`, value.value || 2)}
      />
    </div>
  );
};

PeriodField.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.object,
  }),
  form: PropTypes.shape({
    setFieldValue: PropTypes.func,
    errors: PropTypes.object,
    submitCount: PropTypes.number,
  }),
  label: PropTypes.string,
  isEdit: PropTypes.bool,
  isInline: PropTypes.bool,
  isTerm: PropTypes.bool,
  onEdit: PropTypes.func,
};

PeriodField.defaultProps = {
  isEdit: true,
};

export default PeriodField;
